(function () {
  'use strict';
  /**
    * Release Version - 0.5.x
    *
    * __Utils : 0.9.15 - 05 JAN 2018
    *
    *-------------------------------------------------------- */

  angular.module("lw.core.utils", []).
    service("__Utils", [__Utils]);

  function __Utils() {

    this.log = function (text, textStyle) {

      if (window.appConfig && window.appConfig.debug) {

        var consoleTextStyle = '',
          prependForStyle = '';

        if (textStyle && _.isString(text)) {
          consoleTextStyle = textStyle;
          prependForStyle = '%c ';

          console.log(prependForStyle + text, consoleTextStyle);
        } else {
          console.log(text);
        }

      }
    };

    this.syntaxHighlight = function (json) {
      json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
        var cls = 'color: darkorange;'; /*number*/
        if (/^"/.test(match)) {
          if (/:$/.test(match)) {
            cls = 'color: red;'; /*key*/
          } else {
            cls = 'color: green;'; /*string*/
          }
        } else if (/true|false/.test(match)) {
          cls = 'color: blue;'; /*boolean*/
        } else if (/null/.test(match)) {
          cls = 'color: magenta;'; /*null*/
        }
        return '<span style="' + cls + '">' + match + '</span>';
      });
    };

    this.displayInTabWindow = function (text) {

      if (window.appConfig && window.appConfig.debug) {
        if (text) {
          var textToPrint = '';
          if (_.isObject(text)) {

            if (_.has(text, 'data')) {
              textToPrint = '<pre style="font-size:14px; outline: 1px solid #ccc; padding: 10px; margin: 0px;"><strong>URL: </strong>' + text.config.url + ' <strong><br>Method: </strong>' + text.config.method + ' <strong><br>statusText: </strong>' + text.statusText + ' (' + text.status + ') <strong style="color:red"><br>Error Message: ' + text.data.message + '</strong></pre>';
            }
            textToPrint += '<pre style="outline: 1px solid #ccc; padding: 5px; margin: 0px;">' + this.syntaxHighlight(JSON.stringify(text, null, 4)) + '</pre>';
          } else {
            textToPrint = text;
          }


          var dynamicTabWindow = window.open('', '_blank');
          dynamicTabWindow.document.write(textToPrint);
          dynamicTabWindow.document.close(); // necessary for IE >= 10
          dynamicTabWindow.focus(); // necessary for IE >= 10
        } else {
          console.log("__Utils: Text not found for window.")
        }
      }
    };

    this.openEmailDebugView = function (url) {

      if (window.appConfig && window.appConfig.debug) {
        window.open(url, "__emailDebugView");
        this.info("Request Sent to open Email Debug View.");
      }
    };

    this.error = function (text) {

      if (window.appConfig && window.appConfig.debug) {
        console.error(text);
      }
    };

    this.info = function (text) {

      if (window.appConfig && window.appConfig.debug) {
        console.info(text);
      }
    };

    this.warn = function (text) {

      if (window.appConfig && window.appConfig.debug) {
        console.warn(text);
      }
    };

    this.throwError = function (text) {

      if (window.appConfig && window.appConfig.debug) {
        throw new Error(text);
      }
    };

    this.jsdd = function (response) {

      if (window.appConfig && window.appConfig.debug) {

        if (response.__dd && response.__pr) {
          if (!response.__prExecuted) {
            var prCount = 1;
            _.forEach(response.__pr, function (__prValue) {

              var debugBacktrace = '';

              console.log('%c Server __pr ' + prCount + " --------------------------------------------------", 'color:#f0ad4e');

              _.forEach(__prValue, function (value, key) {

                if (key !== 'debug_backtrace') {
                  console.log(value);

                } else {

                  debugBacktrace = value;
                }
              });

              console.log('%c Reference  --------------------------------------------------', 'color:#f0ad4e');
              console.log(debugBacktrace);

              prCount++;
            });
            response.__prExecuted = true;
            console.log("%c ------------------------------------------------------------ __pr end", 'color: #f0ad4e');
          }
        }

        if (response.__dd && response.__clog) {
          if (!response.__clogExecuted) {
            __globals.clog(response);

            response.__clogExecuted = true;
          }
        }

        if (response.__dd && response.__dd === '__dd') {
          if (!response.__ddExecuted) {
            console.log('%c Server __dd  --------------------------------------------------', 'color:#ff0000');
            var ddCount = 1;
            _.forEach(response.data, function (value, key) {

              if (key !== 'debug_backtrace') {
                //  console.log('%c __dd item '+ ddCount+" --------------------------------------------------", 'color:#ff0000');
                console.log(value);
                ddCount++;
              } else {
                console.log('%c Reference  --------------------------------------------------', 'color:#ff0000');
                console.log(value);
              }
            });
            response.__ddExecuted = true;
          }

          console.log("%c ------------------------------------------------------------ __dd end", 'color: #ff0000');

          throw '------------------------------------------------------------ __dd end.';
        }
      }
    };

    this.time = function (text) {

      if (window.appConfig && window.appConfig.debug && (__globals.detectIE() >= 11 || __globals.detectIE() == false)) {
        console.time(text);
      }
    };

    this.timeEnd = function (text) {

      if (window.appConfig && window.appConfig.debug && (__globals.detectIE() >= 11 || __globals.detectIE() == false)) {
        console.timeEnd(text);
      }
    };


    /**
     * Get URL string based on Laravel Routes.
     *
     * @param  string/object route
     * @param  params object  
     *     
     * @return string
     *-------------------------------------------------------- */

    this.apiURL = function (route, params) {

      var strNewURL = window.appConfig['appBaseURL'];

      if (_.isObject(route) && _.has(route, 'apiURL')) {

        strNewURL = strNewURL + window.__appImmutables.routes[route.apiURL];

        if (_.isObject(route)) {

          _.forEach(route, function (value, key) {

            if (key !== 'apiURL') {
              strNewURL = strNewURL.replace("{" + key + "}", value);
            }

          });

        }

      } else if (_.isString(route)) {

        strNewURL = strNewURL + window.__appImmutables.routes[route];

        if (_.isObject(params)) {

          _.forEach(params, function (value, key) {

            strNewURL = strNewURL.replace("{" + key + "}", value);

          });

        }

      } else {

        this.error("__Utils:: Invalid API url");

      }

      return strNewURL;

    };

    /**
     * Get URL template url for Laravel views/template.
     *
     * @param  string viewName
     *     
     * @return string
     *-------------------------------------------------------- */
    this.getTemplateURL = function (viewName) {

      var strNewURL,
        viewName = viewName.replace(/\//g, ".");
      var params = [
        { find: "viewName", replace: viewName }
      ];
      strNewURL = window.appConfig['appBaseURL'] + window.__appImmutables.routes["template.get"];

      // replace routename from strNewURL to get valid template URL
      for (var i = params.length - 1; i >= 0; i--) {

        strNewURL = strNewURL.replace("{" + params[i].find + "}", params[i].replace);

      }

      return strNewURL;

    };

    /**
     * Underscore template compilation utility
     *
     * @param string {templateName} - html template identifier including (# for id or . for class)
     * @param object {dataObj}
     *     
     * @return formatted html
     *-------------------------------------------------------- */

    this.template = function (templateName, dataObj) {

      var $templateHtml = $("script" + templateName).html();

      if ($templateHtml) {

        var _template = _.template($templateHtml);

        return _template(dataObj);

      } else {
        return dataObj;
      }
    };

    /**
     * Convert String to slug (url-friendly) utility
     *
     * @param string {rawText} - row string
     *     
     * @return url-friendly string
     *-------------------------------------------------------- */

    this.convertToSlug = function (rawText) {

      if (rawText) {

        return rawText
          .toLowerCase()
          .replace(/[^\w ]+/g, '')
          .replace(/ +/g, '-')
          ;
      }
    };

    /**
     * 
     * convert number values of object to string
     *
     * @param object {object} - object
     *     
     * @return object
     *-------------------------------------------------------- */

    this.objectNumberValuesToString = function (object) {

      return _.mapValues(object, function (value) {

        if (_.isNumber(value)) {

          return String(value);

        } else {

          return value;

        }
      });
    };

    /**
     * 
     * object/array to json string
     *
     * @param object {value} - object
     *     
     * @return string
     *-------------------------------------------------------- */

    this.jsonStringify = function (value) {

      return JSON.stringify(value);

    };

    /**
     * 
     * Stringify all object/array values
     *
     * @param object/array {object}
     *     
     * @return object/array
     *-------------------------------------------------------- */

    this.stringifyObjectValues = function (object) {

      var _utils = this;

      return _.mapValues(object, function (value) {

        if (_.isNumber(value)) {

          return String(value);

        } else if (_.isArray(value) || _.isObject(value)) {

          return _utils.stringifyObjectValues(value);

        } else {

          return value;

        }

      });
    };

    /**
      * Delay action for particuler time
      *
      * @return object
      *---------------------------------------------------------------- */

    this.delayAction = function (callbackFunction, delayInitialLoading) {

      var delayInitialLoading = (delayInitialLoading
        && _.isNumber(delayInitialLoading))
        ? delayInitialLoading
        : 300;
      setTimeout(function () {

        callbackFunction.call(this);

      }, delayInitialLoading);
    };

    /**
     * 
     * generate random string id
     *     
     * @return object
     *-------------------------------------------------------- */
    this.generateUID = function () {
      return Math.random().toString(36).substr(2, 9);
    }

    /**
     * 
     * Get XSRF token from cookie
     *     
     * @return object
     *-------------------------------------------------------- */
    this.getXSRFToken = function () {

      var xsrfValue = "",
        bb = "",
        pCOOKIES = [];
      pCOOKIES = document.cookie.split('; ');

      for (bb = 0; bb < pCOOKIES.length; bb++) {

        var rawCookieVal = [];
        rawCookieVal = pCOOKIES[bb].split('=');

        if (rawCookieVal[0] == 'XSRF-TOKEN') {
          xsrfValue = unescape(rawCookieVal[1]);
        }

      }

      __appImmutables.security_token = xsrfValue;

      return xsrfValue;

    };

  };

})();
